
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import Typeahead from './Typeahead.vue';
import TextInput from '../formComponents/core/TextInput.vue';
import { SearchSuggestion } from '@/contract/suggestion.contract';

/**
 * A Searchbar with integrated typeahead which is fully customizable and loadable asynchronously.
 *
 * @version 1.0.0
 * @author AE Tailors
 *
 */
@Component({ components: { Typeahead, TextInput } })
export default class SearchBar<T extends SearchSuggestion> extends Vue {
  /**
   * The type of the native input (html)element used in this searchbar.
   */
  @Prop({ default: 'text', type: String, required: false })
  public type!: string;

  /**
   * The placeholder text for the searchbar.
   */
  @Prop({ required: false, type: String, default: '' })
  public placeholder!: string;

  /**
   * The data which is shown in the typeahead component. This can also be a promise which must resolve to an array.
   */
  @Prop({ required: true, default: [] })
  public typeaheadData!: T[] | Promise<T[]>;

  /**
   * Configuration for this searchbar.
   * @values clearOnSelect
   */
  @Prop({ default: () => ({ clearOnSelect: true }), type: Object })
  public options!: { clearOnSelect: boolean };

  public inputText = '';

  public selectedItem: T | null = null;

  public inputElement: TextInput | null = null;
  public typeahead: Vue | null = null;

  public searchBarRef = `searchBar`;
  public typeaheadRef = `typeahead`;

  public emitSelected(): void {
    /**
     * Emits the selected item selected in the typeahead component.
     * @event selected
     */
    this.$emit('selected', this.selectedItem);
    if (this.options.clearOnSelect) {
      this.inputText = '';
    }
  }

  public onInput(input: string) {
    /**
     * Emits the content of the searchbar in plain text.
     * @event input
     */
    this.$emit('input', input);
  }

  public updateInput(entry: { item: T; index: number }) {
    if (!entry) {
      this.inputText = '';
      return;
    }

    this.inputText = entry.item.suggestionLabel;
  }

  public mounted() {
    this.inputElement = this.$refs[this.searchBarRef] as TextInput;
    this.typeahead = this.$refs[this.typeaheadRef] as Vue;
  }
}
